<template>
  <div
    v-if="isAuthenticated"
    class="d-flex"
    :class="{
      'ga-3': isLongPrice && !isMobile,
      'flex-column': isMobile,
      'flex-row': !isMobile,
      'align-end': !isMobile,
      'align-start': isMobile,
    }"
  >
    <div
      class="d-flex"
      :class="{
        'flex-row': isMobile,
        'flex-column': !isMobile,
        'ga-3': isMobile,
        'align-center': isMobile,
      }"
    ></div>
    <div
      class="d-flex flex-column"
      :class="{
        'align-end': !isMobile,
        'align-start': isMobile,
      }"
    >
      <div class="d-flex  flex-column ga-1">
        <span class="price-label">{{
          $t("Products.productItem.priceLabel")
        }}</span>
        <div class="prices-wrappar d-flex flex-row align-center ga-2 align-center">
          <div v-if="originPrice && !discountPrice" class="discount-price">
            ₪{{ originPrice?.toFixed(2) }}
          </div>
          <div v-if="originPrice && discountPrice" class="origin-price">
            ₪{{ originPrice?.toFixed(2) }}
          </div>
          <div v-if="discountPrice" class="discount-price">
            ₪{{ discountPrice?.toFixed(2) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    discountPrice: {
      type: Number,
      default: undefined,
    },
    originPrice: {
      type: Number,
      default: undefined,
    },
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "AuthModule/isAuthenticated",
      isMobile: "isMobile",
    }),
    isLongPrice() {
      if (("" + this.discountPrice)?.length > 3) return false;
      else return true;
    },
  },
};
</script>

<style scoped lang="scss">
.price-label {
  max-width: 100px;
  line-height: 1;
  text-align: start;
}
.origin-price {
  font-weight: 400px;
  color: #b7b7b7;
  text-decoration: line-through;
  font-size: $smallTextSize;
}
.discount-price {
  line-height: 21px;
  font-size: 21px;
}
.isMobile {
  .discount-price,
  .origin-price {
    font-size: 16px;
  }
}
</style>
